import { useEffect } from "react";
import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const MinpakuRootPage = () => {
  const navigate = useNavigationModule();

  useEffect(() => {
    navigate.push("splash", {});
  }, [navigate.push]);

  return <AnimatedPageTransition />;
};
